<script setup>
import { getI18n } from '@/plugins/i18n'

const i18n = getI18n()

defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['update:modelValue'])
</script>
<template>
  <q-btn
    flat
    round
    dense
    :icon="modelValue ? 'mdi-pencil-off' : 'mdi-pencil'"
    :color="modelValue ? 'primary' : 'grey-6'"
    @click="emit('update:modelValue', !modelValue)"
  >
    <q-tooltip>{{ modelValue ? i18n.t('common.done') : i18n.t('common.edit') }}</q-tooltip>
  </q-btn>
</template>
